var render = function render(){var _vm=this,_c=_vm._self._c;return (!!_vm.asthmaQuestion)?_c('keep-alive',[_c(_vm.asthmaQuestion,_vm._b({tag:"component",model:{value:(_vm.modelValue),callback:function ($$v) {_vm.modelValue=$$v},expression:"modelValue"}},'component',_vm.questionData,false))],1):_c('div')
}
var staticRenderFns = []

export { render, staticRenderFns }